import { render, staticRenderFns } from "./MapLands.vue?vue&type=template&id=433ea853&scoped=true&"
import script from "./MapLands.vue?vue&type=script&lang=js&"
export * from "./MapLands.vue?vue&type=script&lang=js&"
import style0 from "./MapLands.vue?vue&type=style&index=0&id=433ea853&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433ea853",
  null
  
)

export default component.exports